// Module
var code = `<div class="HOA-flextable-component HOA-flextable-component__form">
    <div [ngClass]="{ 'is-invalid': passwordValidationData.passwordStrength === 'Invalid Character' || passwordError}"
         class="Field
                        u-padding-bottom-0-i
                        HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                        HOA-flextable-component__cell--100-field
                        HOA-flextable-component__cell-field">
        <div class="HOA-flex-center-info-button">
            <label tid="passwordLabelShowPassword"
                   class="Field-label HOA-flex-center-info-button" for="passwordSec">
                Password
                <span class="asterisk-required">&nbsp;&#42;</span>
            </label>
        </div>

        <input tid="password"
               id="passwordSec"
               name="password"
               type="{{ showPassword ? 'text' : 'password' }}"
               class="Input"
               [(ngModel)]="userPassword.password"
               (input)="analyzePassword();password()"
               (blur)="hasPasswordInputBlurred = true"
               required
               aria-invalid="false"
               aria-describedby="password-strength-detail-secure"
               attr.aria-describedby="{{passwordError && 'password-error' || undefined }}">

        <div [ngClass]="{ 'is-invalid': hasPasswordInputBlurred &&
                                                (passwordValidationData.showPasswordInvalidMessage ||
                                                    !(passwordValidationData.passwordStrength === 'Good' ||
                                                        passwordValidationData.passwordStrength === 'Strong')) }"
             class="Field u-pA0">
                    <span tid="passwordErrorShowPassword"
                          class="Field-error">
                        Password must meet the requirements.
                    </span>
        </div>

        <div class="HOA-flex-component HOA-flextable-component__space-between u-pT1">
            <div class="Field-detail">
                <div tid="passwordReqLabelShowPassword" class="u-mB2">
                    Password Requirements
                </div>
                <div>
                            <span tid="passwordReq1IconShowPassword"
                                  [ngClass]="userPassword.password.length >= 13 ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline Icon Icon--24
                                        icon-utility-basics-check_circle_fill-24
                                        background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>Must be at least 13 characters</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                            1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                            14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq1TextShowPassword"
                          [ngClass]="userPassword.password.length >= 13 ? 'u-fontGreenDark' : 'u-fontGray z-is-off'">
                                Must be at least 13 characters
                            </span>
                </div>
                <div>
                            <span tid="passwordReq7IconShowPassword"
                                  [ngClass]="!passwordContainsFirstName ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline Icon Icon--24
                                        icon-utility-basics-check_circle_fill-24
                                        background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>Does not contain your first name</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                            1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                            14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq7TextShowPassword"
                          [ngClass]="!passwordContainsFirstName ? 'u-fontGreenDark' : 'u-fontGray z-is-off'">
                                Does not contain your first name
                            </span>
                </div>
                <div>
                            <span tid="passwordReq8IconShowPassword"
                                  [ngClass]="!passwordContainsLastName ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline Icon Icon--24
                                        icon-utility-basics-check_circle_fill-24
                                        background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>Does not contain your last name</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                            1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                            14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq8TextShowPassword"
                          [ngClass]="!passwordContainsLastName ? 'u-fontGreenDark' : 'u-fontGray z-is-off'">
                                Does not contain your last name
                            </span>
                </div>
                <div>
                            <span tid="passwordReq2IconShowPassword"
                                  [ngClass]="!passwordContainsUsername ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline Icon Icon--24
                                        icon-utility-basics-check_circle_fill-24
                                        background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>Does not contain part of your email</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                          1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                          14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq2TextShowPassword"
                          [ngClass]="!passwordContainsUsername ? 'u-fontGreenDark' : 'u-fontGray z-is-off'">
                                Does not contain part of your email
                            </span>
                </div>
                <div>
                            <span tid="passwordReq3IconShowPassword"
                                  [ngClass]="lowerCaseCharExists ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline
                                        Icon
                                        Icon--24
                                        icon-utility-basics-check_circle_fill-24
                                        background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>A lowercase letter</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                            1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                            14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq3TextShowPassword"
                          [ngClass]="lowerCaseCharExists ? 'u-fontGreenDark z-is-on' : 'u-fontGray z-is-off'">
                                A lowercase letter
                            </span>
                </div>
                <div>
                            <span tid="passwordReq4IconShowPassword"
                                  [ngClass]="upperCaseCharExists ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline
                                        Icon
                                        Icon--24
                                        icon-utility-basics-check_circle_fill-24
                                        background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>An uppercase letter</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                            1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                            14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq4TextShowPassword"
                          [ngClass]="upperCaseCharExists ? 'u-fontGreenDark z-is-on' : 'u-fontGray z-is-off'">
                                An uppercase letter
                            </span>
                </div>
                <div>
                            <span tid="passwordReq5IconShowPassword"
                                  [ngClass]="numericCharExists ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline
                                        Icon
                                        Icon--24
                                        icon-utility-basics-check_circle_fill-24
                                        background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>A number</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                              1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                              14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq5TextShowPassword"
                          [ngClass]="numericCharExists ? 'u-fontGreenDark z-is-on' : 'u-fontGray z-is-off'">
                                A number
                            </span>
                </div>
                <div>
                            <span tid="passwordReq6IconShowPassword"
                                  [ngClass]="specialCharExists ? 'u-fillGreen z-is-on' : 'u-fillGrayLight z-is-off'"
                                  class="Field--inline
                                         Icon
                                         Icon--24
                                         icon-utility-basics-check_circle_fill-24
                                         background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>A listed special character</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                            1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                            14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq6TextShowPassword"
                          [ngClass]="specialCharExists ? 'u-fontGreenDark z-is-on' : 'u-fontGray z-is-off'">
                                A listed special character:&nbsp;&nbsp; ! @ # \$ - _ /
                            </span>
                </div>
            </div>
        </div>
    </div>

    <div [ngClass]="{ 'is-invalid': confirmPasswordError ||
                            (!passwordValidationData.passwordsMatch && !confirmPasswordError && confirmFocused)}"
         class="Field
                        HOA-flextable-component__cell--50-ifSizeIsLargerThanPhone
                        HOA-flextable-component__cell--100-field
                        HOA-flextable-component__cell-field">
        <label class="Field-label" for="confirmPasswordSec">
            Confirm Password
            <span class="asterisk-required">&nbsp;&#42;</span>
        </label>
        <input type="{{ showPassword ? 'text' : 'password' }}"
               class="Input"
               id="confirmPasswordSec"
               tid="confirmPassword"
               name="confirmPassword"
               [(ngModel)]="confirmUserPassword"
               (input)="analyzePassword();password();confirmPassword()"
               required
               aria-invalid="false"
               attr.aria-describedby="{{confirmPasswordError && 'confirmPasswordSec-error' || undefined }}">
        <!--<span class="Field-error" id="confirmPasswordSec-error">The passwords do not match.</span>-->
        <div class="HOA-flex-component HOA-flextable-component__space-between u-pT1" id="Field-detail1?">
            <div class="Field-detail">
                <div tid="passwordReqLabelShowPassword" class="u-mB2">
                    Confirm Password Requirements
                </div>
                <div>
                            <span tid="passwordReq1IconShowPassword"
                                  [ngClass]="!(!passwordValidationData.passwordsMatch && !confirmPasswordError) && confirmFocused ?
                                        'u-fillGreen z-is-on' :
                                        'u-fillGrayLight z-is-off'"
                                  class="Field--inline
                                         Icon
                                         Icon--24
                                         icon-utility-basics-check_circle_fill-24
                                         background-image-none">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     width="20"
                                     height="20"
                                     viewBox="0 0 72 72">
                                    <title>Passwords must match</title>
                                    <path class="fill_layer"
                                          d="M36.3 9a27 27 0 1 0 27 27 27 27 0 0 0-27-27zm13.2 15.3L34 48.9a1.1 1.1 0 0
                                            1-.8.5H33a1.1 1.1 0 0 1-.8-.3l-9.1-9.3a1.1 1.1 0 0 1 1.6-1.6l8.1 8.3
                                            14.8-23.4a1.1 1.1 0 0 1 1.9 1.2z"
                                          fill="#838383"
                                          stroke-width="3.8">
                                    </path>
                                </svg>
                            </span>
                    <span tid="passwordReq1TextShowPassword"
                          [ngClass]="!(!passwordValidationData.passwordsMatch && !confirmPasswordError) && confirmFocused ?
                                        'u-fontGreenDark z-is-on' :
                                        'u-fontGray z-is-off'">
                                Passwords must match
                            </span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="HOA-flextable-component HOA-flextable-component__form">
    <div class="HOA-flextable-component__cell-field u-mT2">
        <input type="checkbox"
               id="showPasswordToggle"
               name="showPasswordToggle"
               tid="showPasswordToggle"
               style="margin-bottom: 26px;
                                            accent-color: #00505c;
                                            height: 15px"
               [(ngModel)]="showPassword"
               [ngClass]="{'is-invalid': false}">
        <label for="showPasswordToggle" class="HOA-font-light">Show Password</label>
    </div>
</div>`;
// Exports
module.exports = code;